import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8.75 10H4.167m-.07.243L2.15 16.055c-.153.457-.23.685-.175.826a.42.42 0 0 0 .276.25c.146.04.365-.059.804-.256l13.927-6.267c.428-.193.643-.29.709-.423a.42.42 0 0 0 0-.37c-.066-.134-.28-.23-.71-.423L3.053 3.123c-.438-.197-.657-.295-.802-.255a.42.42 0 0 0-.276.25c-.056.14.02.367.171.823l1.952 5.88c.026.079.039.118.044.158a.4.4 0 0 1 0 .107 1 1 0 0 1-.045.157"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }